import React from 'react';
import SEO from '../components/SEO';
import './GrowIQ.css';

const features = [
  { icon: '🧠', title: 'Interactive Learning', desc: 'Engage with content actively through quizzes designed to test and enhance your knowledge across hundreds of topics.' },
  { icon: '📚', title: 'Diverse Categories', desc: 'Explore quizzes covering technology, history, science, arts, general knowledge, SQL, programming, and beyond.' },
  { icon: '📈', title: 'Track Your Progress', desc: 'See your scores, monitor improvement, and identify areas for further learning as you build expertise over time.' },
  { icon: '🎯', title: 'Challenge Yourself', desc: 'Test your limits with progressively harder quizzes. Compete with the community and top the leaderboards.' },
  { icon: '🔍', title: 'Smart Search', desc: 'Find any quiz instantly with powerful search. Browse by category or jump straight to your favorite topics.' },
  { icon: '📱', title: 'Use Anywhere', desc: 'Access GrowIQ directly from your browser — no install required. Learn on any device, anywhere.' },
];

const GrowIQ = () => (
  <div className="product-page">
    <SEO
      title="GrowIQ — Grow Your Knowledge with Interactive Quizzes | Appshow"
      description="Discover hundreds of quizzes across technology, history, science, arts, and more. Track your progress and challenge yourself with GrowIQ's interactive learning platform."
      keywords="quiz app, interactive learning, knowledge quiz, study app, trivia, educational platform, GrowIQ"
      url="/growiq"
    />

    <section className="pp-hero">
      <div className="container pp-hero-inner">
        <div className="pp-hero-content">
        <div className="pp-hero-meta">
          <span className="badge-live">Live</span>
          <span className="pp-category">Education</span>
        </div>
        <h1 className="pp-title">GrowIQ</h1>
        <p className="pp-subtitle">Grow Your Knowledge with Interactive Quizzes</p>
        <p className="pp-description">
          Discover hundreds of quizzes across various categories. Test your knowledge, learn new facts, and
          challenge yourself with our interactive learning platform. Join thousands of users transforming
          the way they learn, one quiz at a time.
        </p>
        <div className="pp-store-buttons">
          <a
            href="https://growiq.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-store-large"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
            </svg>
            <span>
              <span className="btn-store-sub">Visit</span>
              <span className="btn-store-main">growiq.app</span>
            </span>
          </a>
        </div>
        <p className="pp-note">Free · Web App · Works on any device</p>
        </div>
        <div className="pp-hero-preview">
          <img
            src="/images/growiq/growiq-interactive-quiz-app-preview.png"
            alt="GrowIQ interactive quiz app preview – grow your knowledge with quizzes"
            className="pp-preview-img"
          />
        </div>
      </div>
    </section>

    <section className="pp-features">
      <div className="container">
        <h2 className="pp-section-title">Why Learn with GrowIQ?</h2>
        <div className="features-grid">
          {features.map((f, i) => (
            <div className="feature-card" key={i}>
              <div className="feature-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="pp-cta">
      <div className="container">
        <h2>Start learning today</h2>
        <p>Free to use. No account required. Open in any browser.</p>
        <div className="pp-store-buttons">
          <a href="https://growiq.app/" target="_blank" rel="noopener noreferrer" className="btn-store-large">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
            </svg>
            <span><span className="btn-store-sub">Visit</span><span className="btn-store-main">growiq.app</span></span>
          </a>
        </div>
      </div>
    </section>
  </div>
);

export default GrowIQ;
